export default __webpack_public_path__ + "5a801b9778b0144b5dae289a5ddf65b0.svg";